<template>
  <div class="button-grid">
    <Button
      v-if="!isReadOnly"
      @click="onSave"
      :label="$t('save')"
      class="p-button-success "
      icon="pi pi-check"
    />

    <ConfirmButton
      v-if="!isReadOnly"
      colorVariant="success"
      :disabled="emailButtonDisabled()"
      :callbackId="this.appointmentCapacity.appointment.id"
      :confirmCallback="onSendAppointmentConfirmationMail"
      class=" p-button-secondary"
    >
      <template v-slot:buttonText>
        <span class="pi pi-envelope p-button-icon p-button-icon-left"></span>
        <span class="p-button-label ml-2">Termin bestätigen</span>
      </template>
      <template v-slot:header> {{ $t('confirm_appointment') }}? </template>
      <template v-slot:confirmButtonText>
        {{ $t('confirm_appointment') }}
      </template>
      <template v-slot:content>
        E-Mail-Bestätigung wird versendet an:
        <strong
          v-if="
            appointmentCapacity.appointment.project &&
              appointmentCapacity.appointment.project.customer.email
          "
        >
          {{ appointmentCapacity.appointment.project.customer.email }}</strong
        >
      </template>
    </ConfirmButton>

    <Button
      @click="onCancel"
      :label="$t('cancel')"
      class="p-button-secondary "
      icon="pi pi-times"
    />

    <ConfirmDeleteButton
      v-if="!isReadOnly"
      class="p-button-secondary"
      :disabled="!canDelete"
      :confirmCallback="onDelete"
    >
      <template #buttonText> {{ $t('slot') }} {{ $t('delete') }} </template>
    </ConfirmDeleteButton>

    <ConfirmDeleteButton
      v-if="!isReadOnly"
      class="p-button-secondary"
      :disabled="!canDeleteAppointment"
      :confirmCallback="onDeleteAppointment"
    >
      <template #buttonText> {{ $t('appointment') }} {{ $t('delete') }} </template>
    </ConfirmDeleteButton>
  </div>
</template>

<script>
import Button from 'primevue/button';
import ConfirmButton from '@/components/ConfirmButton.vue';
import ConfirmDeleteButton from '@/components/ConfirmDeleteButton.vue';

export default {
  props: [
    'appointmentCapacity',
    'canDelete',
    'canDeleteAppointment',
    'onSave',
    'onCancel',
    'onDelete',
    'onDeleteAppointment',
    'emailButtonDisabled',
    'onSendAppointmentConfirmationMail',
    /** Viewer of the slots: only cancel, no save, mail or delete. */
    'isReadOnly',
  ],
  components: {
    Button,
    ConfirmButton,
    ConfirmDeleteButton,
  },
};
</script>

<style scoped lang="scss">
.button-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5em;
}
</style>
